import React, { useContext, useEffect, useState } from "react";
import "./About_Section.css";
import { Context } from "../../../utils/context";
import { getCount } from "../../../utils/apis/common/Common";
import { AboutFalcon } from "../../../utils/apis/aboutus/Aboutus";
import { IDS } from "../../../utils/common";

const About_Section = () => {

 var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [counter, setCounter] = useState([]);

  const [aboutFalcon, setAboutFalcon] = useState([]);

  const getCounter = async () => {
    const res = await getCount();
    if (res?.success) {
      setCounter(res.data);
    }
  };

  const getAboutFalcon = async () => {
    const res = await AboutFalcon();
    if (res?.success) {
      setAboutFalcon(res.data);
    }
  };

  useEffect(() => {
    getCounter();
    getAboutFalcon();
  }, []);
  return (
    <section className="about-section">
      <div className="container">
        <div className="bg-img-section">
          <div className="about-header">
            <h5 className="title">
              About{" "}
              <span>
                Falcon <span className="red-text">SFX</span>
              </span>
            </h5>
            <h2 className="sub-title">Powering Unforgettable Experiences</h2>
          </div>

            {aboutFalcon?.map((item, index) => (
          <div className="about-content" key={index}>
            <div className="about-text">
              <p className="desc">
                {/* Falcon <span className="red-text">SFX</span> is a premier
                special effects company dedicated to bringing creative visions
                to Events through precision, innovation, & expertise. We
                specialize in delivering high-impact visual effects for Live
                concerts, weddings & Corporate Events. With a strong focus on
                safety, quality, & seamless execution, we turn ordinary moments
                into extraordinary experiences. */}
                {htmlToReactParser.parse(item?.description)}
              </p>
            </div>

            <div className="about-images">
              <img src={IDS?.IMG_URL + item?.image} alt="Stage Fire" />
            </div>
          </div>
            ))}
          {/* <div className="about-content">
            <div className="about-text">
              <p className="desc">
                Turn every moment into a spectacle from concerts & weddings to
                corporate shows & festivals, we deliver safe, reliable, and
                visually stunning effects that wow every crowd.
              </p>
            </div>

            <div className="about-images">
              <img src="/assets/images/newhome/about1.png" alt="Stage Fire" />
            </div>
          </div> */}
        </div>
        <div className="stats-section">
          <div className="stats-container">

            {counter.map((item, index) => (
              <div className="stat-item" key={index}>
                <h2>{item?.count}</h2>
                <p className="text">{item?.name}</p>
              </div>
            ))}

            {/* <div className="stat-item">
              <h2>50,000+</h2>
              <p className="text">Special Effects Fired</p>
            </div>

            <div className="stat-item">
              <h2>05+</h2>
              <p className="text">years of experience</p>
            </div>

            <div className="stat-item">
              <h2>100%</h2>
              <p className="text">Safety Record</p>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About_Section;
